var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 0.666626C4.40841 0.666626 0.666748 4.40829 0.666748 8.99996C0.666748 13.5916 4.40841 17.3333 9.00008 17.3333C13.5917 17.3333 17.3334 13.5916 17.3334 8.99996C17.3334 4.40829 13.5917 0.666626 9.00008 0.666626ZM12.9834 7.08329L8.25841 11.8083C8.14175 11.925 7.98341 11.9916 7.81675 11.9916C7.65008 11.9916 7.49175 11.925 7.37508 11.8083L5.01675 9.44996C4.77508 9.20829 4.77508 8.80829 5.01675 8.56663C5.25841 8.32496 5.65841 8.32496 5.90008 8.56663L7.81675 10.4833L12.1001 6.19996C12.3417 5.95829 12.7417 5.95829 12.9834 6.19996C13.2251 6.44163 13.2251 6.83329 12.9834 7.08329Z",
    fill: "#27AF97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.258b4b5c052f686448c2f983789d7ecc.svg";
export { ForwardRef as ReactComponent };